module.exports = __webpack_public_path__ + "static/media/Satoshi_Italic.7e048c30.woff2";